import React from "react";
import {
  Paper,
  Box,
  Typography,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  Slider,
  Stack,
  Chip,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/ViewList";

export default function Filters({
  brands,
  categories,
  selectedBrand,
  setSelectedBrand,
  selectedCategory,
  setSelectedCategory,
  maxPriceUsd,
  priceMaxUsd,
  setPriceMaxUsd,
  tags,
  selectedTags,
  setSelectedTags,
  view,
  setView,
  isMobile = false
}) {
  return (
    <Paper sx={{ p: { xs: 2, sm: 2 }, width: '100%', height: 'fit-content' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <TuneIcon sx={{ fontSize: { xs: 20, sm: 24 } }} /> 
          <Typography variant="subtitle2" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Filters
          </Typography>
        </Box>
        <Box>
          <IconButton 
            onClick={() => setView("grid")} 
            color={view === "grid" ? "primary" : "default"} 
            size={isMobile ? "small" : "medium"}
          >
            <GridViewIcon />
          </IconButton>
          <IconButton 
            onClick={() => setView("list")} 
            color={view === "list" ? "primary" : "default"} 
            size={isMobile ? "small" : "medium"}
          >
            <ListIcon />
          </IconButton>
        </Box>
      </Box>

      <Stack spacing={2}>
        <FormControl fullWidth size="small">
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>
            Brand
          </Typography>
          <Select value={selectedBrand} onChange={(e) => setSelectedBrand(e.target.value)}>
            <MenuItem value="">All brands</MenuItem>
            {brands.map(b => <MenuItem key={b} value={b}>{b}</MenuItem>)}
          </Select>
        </FormControl>

        <FormControl fullWidth size="small">
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>
            Category
          </Typography>
          <Select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
            <MenuItem value="">All categories</MenuItem>
            {categories.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </Select>
        </FormControl>

        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
            Max Price (USD)
          </Typography>
          <Box sx={{ px: 1 }}>
            <Slider 
              value={priceMaxUsd} 
              onChange={(e, v) => setPriceMaxUsd(Array.isArray(v) ? v[1] : v)} 
              min={0} 
              max={Math.max(25, Math.ceil(maxPriceUsd))} 
              sx={{ mb: 1 }}
            />
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              Up to ${priceMaxUsd}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
            Tags ({tags.length} available)
          </Typography>
          <Box sx={{ 
            display: "flex", 
            gap: 1, 
            flexWrap: "wrap",
            maxHeight: isMobile ? 'none' : '200px',
            overflowY: isMobile ? 'visible' : 'auto',
            // Add padding for scrollbar when needed
            pr: !isMobile && tags.length > 10 ? 1 : 0
          }}>
            {tags.map(t => 
              <Chip 
                key={t} 
                label={t} 
                size="small" 
                color={selectedTags.includes(t) ? 'primary' : 'default'} 
                variant={selectedTags.includes(t) ? 'filled' : 'outlined'}
                onClick={() => {
                  if (selectedTags.includes(t)) {
                    setSelectedTags(selectedTags.filter(s => s !== t));
                  } else {
                    setSelectedTags([...selectedTags, t]);
                  }
                }} 
                sx={{ 
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: 1
                  }
                }}
              />
            )}
          </Box>
          
          {/* Clear Tags Button */}
          {selectedTags.length > 0 && (
            <Box sx={{ mt: 1, textAlign: 'center' }}>
              <Typography 
                variant="caption" 
                color="primary" 
                sx={{ 
                  cursor: 'pointer', 
                  textDecoration: 'underline',
                  '&:hover': { color: 'primary.dark' }
                }}
                onClick={() => setSelectedTags([])}
              >
                Clear selected tags ({selectedTags.length})
              </Typography>
            </Box>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}